import React from "react";
import InputDatePicker from "./Datepicker";
import styled from "styled-components";
import FormSectionHeader from "./FormSectionHeader";
import InputField from "./InputField";
import { Colors } from "../../config";
import TextArea from "../TextArea";

const LeaveForm = ({
  onLeaveFormChange,
  applyLeaveData,
  errors,
  onFileUpload,
  file,
  onDownloadFile,
  onDeleteFile,
}) => {
  return (
    <>
      <FormSectionHeader label="Leave Details" />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          marginTop: "1rem",
          marginBottom: "2rem",
        }}
      >
        <DatePickerContainer>
          <DateFieldContainer>
            <InputDatePicker
              format="ccc dd-MM-yyyy"
              placeholder="Select Date"
              label="Start Date"
              value={
                applyLeaveData?.startDate
                  ? new Date(applyLeaveData?.startDate)
                  : ""
              }
              onChange={(val) =>
                onLeaveFormChange({
                  target: { value: val, name: "startDate" },
                })
              }
              scrollableYearDropdown
              scrollableMonthDropdown
              dropdownMode="select"
              hideIcon
              placeHolderColor
              helperText={errors["startDate"]}
              required
              minDate={new Date()}
            />
          </DateFieldContainer>
          <DateFieldContainer>
            <InputDatePicker
              format="ccc dd-MM-yyyy"
              placeholder="Select Date"
              label="Expected Return Date"
              value={
                applyLeaveData?.endDate ? new Date(applyLeaveData?.endDate) : ""
              }
              onChange={(val) =>
                onLeaveFormChange({
                  target: { value: val, name: "endDate" },
                })
              }
              scrollableYearDropdown
              scrollableMonthDropdown
              dropdownMode="select"
              hideIcon
              placeHolderColor
              helperText={errors["endDate"]}
              required
              minDate={
                applyLeaveData?.startDate
                  ? new Date(
                      new Date(applyLeaveData.startDate).setDate(
                        new Date(applyLeaveData.startDate).getDate() + 1,
                      ),
                    )
                  : new Date(new Date().setDate(new Date().getDate() + 1))
              }
              disabled={!applyLeaveData?.startDate}
            />
          </DateFieldContainer>
        </DatePickerContainer>
        <AttachmentCommentContainer>
          <DateFieldContainer>
            <TextArea
              isRounded={true}
              label="Purpose of Travel"
              required={true}
              errorText={errors["comments"]}
              value={applyLeaveData?.comments}
              placeholder="Enter purpose of travel here"
              name={"comments"}
              onChange={onLeaveFormChange}
              labelFontSize={"14px"}
              labelFontColor={Colors.black}
            />
          </DateFieldContainer>
          <DateFieldContainer>
            {/* <input type="file" onChange={onFileUpload}/> */}
            <FileCard>
              {!file ? (
                <StyledLabel>
                  <HiddenInput type="file" onChange={onFileUpload} />
                  <UploadIcon>
                    {/* <FiUpload size={22} /> */}
                    <img src={require("../../assets/images/fileupload.png")} />
                  </UploadIcon>
                  <UploadText>Click to upload attachment</UploadText>
                  <HintText>
                    Attach Business trip related communication
                  </HintText>
                </StyledLabel>
              ) : (
                <FilePreview>
                  <FileInfo>
                    {/* <FiFile size={24} color="#d32f2f" /> */}
                    <FileName title={file.name}>
                      {"File has been attached"}
                    </FileName>
                  </FileInfo>
                  <ButtonGroup>
                    <ActionButton variant="download" onClick={onDownloadFile}>
                      Download
                    </ActionButton>
                    <ActionButton variant="delete" onClick={onDeleteFile}>
                      Delete
                    </ActionButton>
                  </ButtonGroup>
                </FilePreview>
              )}
            </FileCard>
          </DateFieldContainer>
        </AttachmentCommentContainer>
      </div>
    </>
  );
};

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  margin: 1rem 0 2rem;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const DateFieldContainer = styled.div`
  flex: 1;
`;

const FileCard = styled.div`
  flex: 1;
  border: 2px dashed ${Colors.brandOne};
  border-radius: 10px;
  padding: 0.5rem;
  margin-top: 1.5rem;
  background-color: #e3e3e3ff;
  text-align: center;
  transition: all 0.3s ease;
  &:hover {
    background-color: ${Colors.white};
  }
`;

const StyledLabel = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  cursor: pointer;
`;

const HiddenInput = styled.input`
  display: none;
`;

const UploadIcon = styled.div`
  background-color: ${Colors.lightAsh};
  // padding: 1rem;
  height: 48px;
  width: 48px;
  border-radius: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const UploadText = styled.span`
  font-weight: 600;
  color: ${Colors.brandOne};
  font-size: 1rem;
`;

const HintText = styled.span`
  font-size: 0.8rem;
  color: #888;
`;

const FilePreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0.75rem;
`;

const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

const FileName = styled.span`
  font-size: 14px;
  font-family: Inter;
  color: ${Colors.brandOne};
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const ActionButton = styled.button`
  background-color: ${({ variant }) =>
    variant === "delete" ? "#ef5350" : ` ${Colors.brandOne}`};
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 0.9rem;
  font-size: 0.9rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 120px;
  justify-content: center;
  &:hover {
    background-color: ${({ variant }) =>
      variant === "delete" ? "#d32f2f" : `${Colors.brandTwo}`};
    transform: translateY(-1px);
  }
`;

const DatePickerContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margintop: 1rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
const AttachmentCommentContainer = styled.div`
  display: flex;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0;
  }
`;

export default LeaveForm;
